var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column gr-6" },
    [
      _c(
        "div",
        {
          staticClass: "px-2",
          class: _setup.isMobile ? "text-h6" : "text-h5 text-center",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_setup.t("Отзывы врачей", _setup.options)) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _setup.isMobile
        ? _c(_setup.SliderCards, {
            attrs: { "doctor-rates": _setup.doctorRates },
          })
        : _c(_setup.SlidingLineCards, {
            staticClass: "align-self-center",
            attrs: { "doctor-rates": _setup.doctorRates },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }